import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/intercom': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M392 32H56C25.1 32 0 57.1 0 88V424C0 454.9 25.1 480 56 480H392C422.9 480 448 454.9 448 424V88C448 57.1 422.9 32 392 32zM283.7 114.1C283.7 94.3 313.6 94.3 313.6 114.1V313.6C313.6 333.4 283.7 333.4 283.7 313.6V114.1zM209.1 106.6C209.1 86.8 239 86.8 239 106.6V323.1C239 342.9 209.1 342.9 209.1 323.1V106.6zM134.4 114.1C134.4 94.3 164.3 94.3 164.3 114.1V313.6C164.3 333.4 134.4 333.4 134.4 313.6V114.1zM59.7 144C59.7 124.2 89.6 124.2 89.6 144V278.3C89.6 298.1 59.7 298.1 59.7 278.3V144zM383.1 371.8C310.3 434.8 141.4 437.2 65 371.8 50 359 69.4 336.3 84.4 349.1 150.3 404.4 300.5 403 363.7 349.1 378.6 336.2 398 358.9 383.1 371.8zM388.3 278.3C388.3 298.1 358.4 298.1 358.4 278.3V144C358.4 124.2 388.3 124.2 388.3 144V278.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/intercom.js
// module id = 8BrN
// module chunks = 144